'use strict';
import request from '@/utils/request';
class CouponsService{
    static list(query){
        return request({
            url:'/coupons',
            method:'get',
            timeout:60000,
            params:query
        })
    }
    static listPublic(query){
        return request({
            url:'/coupons-public',
            method:'get',
            params:query
        })
    }
    static listPrivate(query){
        return request({
            url:'/coupons-private',
            method:'get',
            params:query
        })
    }
    static apply(query){
        return request({
            url:'/company/coupons-apply',
            method:'get',
            timeout:60000,
            params:query
        })
    }
    static create(data){
        return request({
            url:'/company/coupons',
            method:'post',
            data
        });
    }
    static updatePublic(data){
        return request({
            url:'/company/coupons-public',
            method:'put',
            data
        });
    }

    static update(data){
        return request({
            url:'/company/coupons',
            method:'put',
            data
        });
    }
    static remove(data){
        return request({
            url:'/company/coupons',
            method:'delete',
            data
        });
    }
    static search(query){
        return request({
            url:'/company/additional-service/search',
            method:'get',
            params:query
        })
    }
}

export default CouponsService;
